import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const STATUS_COLORS = {
  New: "#0EA5E9",
  Contacted: "#F59E0B",
  Qualified: "#10B981",
  "Offer Sent": "#6366F1",
  "Sample Sent": "#F43F5E",
  Negotiation: "#E1A104",
  Customer: "#1A3A21",
  Sleepy: "#94A3B8",
  Dormant: "#94A3B8",
  Lost: "#EF4444",
  Inactive: "#6B7280",
};

export const PRIORITY_COLORS = { A: "#EF4444", B: "#F59E0B", C: "#3B82F6" };

export const ACTIVITY_ICONS = {
  CALL: "Phone",
  EMAIL: "EnvelopeSimple",
  WHATSAPP: "WhatsappLogo",
  SAMPLE: "Package",
  FOLLOW_UP: "CalendarCheck",
  MEETING: "Users",
  MILESTONE: "Flag",
  ORDER: "ShoppingCart",
  NOTE: "Note",
};

export const ACTIVITY_COLORS = {
  CALL: "#3B82F6",
  EMAIL: "#6366F1",
  WHATSAPP: "#22C55E",
  SAMPLE: "#F43F5E",
  FOLLOW_UP: "#E1A104",
  MEETING: "#8B5CF6",
  MILESTONE: "#1A3A21",
  ORDER: "#1A3A21",
  NOTE: "#6B7280",
};

export function fmtDate(v) {
  if (!v) return "—";
  try {
    return new Date(v).toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  } catch {
    return "—";
  }
}

export function fmtDateTime(v) {
  if (!v) return "—";
  try {
    return new Date(v).toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
}

export function fmtCurrency(v) {
  const n = Number(v || 0);
  return `€${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").map((s) => s[0]).join("").toUpperCase().slice(0, 2);
}
